import { ReactNode } from "react";

import { Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { PrimaryButton } from "@/components/pieces/button/PrimaryButton";

interface ErrorDialogContentProps {
  text?: ReactNode;
  onClose: () => void;
}

export function ErrorDialogContent({ text, onClose }: ErrorDialogContentProps) {
  return (
    <>
      <Callout intent="danger">
        {text || "Something went wrong. Please try again"}
      </Callout>
      <Box mt={20}>
        <PrimaryButton onClick={onClose}>Close</PrimaryButton>
      </Box>
    </>
  );
}
